<template>
  <img :src="srcIcon" :width="width" :height="height" />
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';

const props = defineProps<{
  name?: string;
  width?: string;
  height?: string;
}>();

const setIcon = (name?: string) => {
  if (name) {
    let promise: any = null
    if (name.endsWith('png')) {
      promise = import(`@/assets/${name.replace('.png', '')}.png`)
    } else if (name.endsWith('svg')) {
      promise = import(`@/assets/${name.replace('.svg', '')}.svg`)
    }

    promise.then((mod: any) => srcIcon.value = mod.default)
  }
}

const srcIcon = ref()
watch(() => props.name, setIcon, {
  immediate: true
})


</script>

<style lang="scss" scoped></style>